import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function PricingCard({ plan, price, period, features, cta }) {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCtaClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (location.pathname === '/') {
      scrollToContact();
      return;
    }
    navigate('/');
    setTimeout(scrollToContact, 300);
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        width: '370px',
        height:'450px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        flexShrink: 0,
        alignSelf: 'stretch',   
        transform: hovered ? 'translateY(-6px)' : 'none',
        transition: 'transform 0.3s ease',
      }}
    >
      {/* Accent */}
      <div style={{
        width: '45px', height: '45px', background: '#E47000', borderRadius: '50%',
        position: 'absolute', top: '-20px', left: '20%', transform: 'translateX(-50%)',
        zIndex: 1,
      }} />

      {/* En-tête */}
      <div style={{
        padding: '40px 32px 20px',
        background: '#053965',
        borderRadius: '16px 16px 16px 16px',
      }}>
        <div style={{ fontSize: '12px', fontWeight: '600', color: '#f1f1f1', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '4px', lineHeight: '1' }}>
          {plan}
        </div>
        <div style={{ fontSize: '36px', fontWeight: '800', color: '#fff', lineHeight: '1', marginBottom: '2px' }}>
          {price} <span style={{ fontSize: '15px', fontWeight: '500' }}>FCFA</span>
        </div>
        <div style={{ fontSize: '12px', color: '#fff', lineHeight: '1'}}>{period}</div>
      </div>

      {/* Features — flex: 1 pour occuper toute la hauteur restante */}
      <div style={{
        padding: '35px 24px 24px',
        color: '#000000',
        background: '#F5F5F5B2',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        borderRadius: '0 0 16px 16px',
        flex: 1,                      
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',  
      }}>
        <ul style={{ listStyle: 'none', margin: '0 0 20px', padding: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {features.map((f, i) => (
            <li key={i} style={{ fontSize: '16px', color: '#000000', display: 'flex', gap: '8px', alignItems: 'flex-start', lineHeight: '1.4' }}>
              <span style={{ color: '#E47000', fontWeight: '700', flexShrink: 0 }}>✓</span>
              {f}
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={handleCtaClick}
          style={{
          width: '100%', background: '#E47000', color: '#fff', border: 'none',
          borderRadius: '999px', padding: '11px', fontSize: '13px', fontWeight: '600', cursor: 'pointer',
        }}
        >
          {cta}
        </button>
      </div>
    </div>
  );
}